// src/pages/msBellSchedule.jsx
// Middle School bell schedule display. Thin wrapper over the shared, config-driven
// BellSchedule component — reads bellSchedules/middleSchool live from Firestore,
// so edits published from the MS editor (/ms-bell-editor) appear here within seconds.
// All schedule logic and styling live in BellSchedule.jsx; this only picks the division.

import BellSchedule from "./BellSchedule";
export default function MsBellSchedule() {
  return <BellSchedule division="middleSchool" />;
}